import {
  Home as HomeIcon,
  BarChart as BarChartIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  Briefcase as BriefcaseIcon,
  Layers as LayersIcon,
  Package as PackageIcon,
  Users as UsersIcon,
  Star as StarIcon,
  List as TermsIcon,
  DollarSign as DollarIcon,
  CreditCard as CreditCardIcon,
  Archive as ContractsIcon,
  Award as AwardIcon,
  Eye as ActivityIcon,
  MessageCircle as ConversationsIcon
} from 'react-feather';

const MENU_ITEMS = Object.freeze([
  {
    href: '/app/dashboard',
    icon: HomeIcon,
    title: 'Dashboard',
    scope: ['read:dashboard', 'write:dashboard']
  },
  {
    href: '/app/customers',
    icon: StarIcon,
    title: 'Clientes',
    scope: ['read:customers', 'write:customers']
  },
  {
    href: '/app/contracts',
    icon: ContractsIcon,
    title: 'Contratos',
    scope: ['read:contracts', 'write:contracts']
  },
  {
    href: '/app/contract-types',
    icon: ShoppingBagIcon,
    title: 'Tipos de contratos',
    scope: ['read:contract-types', 'write:contract-types']
  },
  {
    href: '/app/terms',
    icon: TermsIcon,
    title: 'Cuotas pendientes',
    scope: ['read:pending-terms', 'write:pending-terms']
  },
  {
    href: '/app/billing',
    icon: DollarIcon,
    title: 'Facturación',
    scope: ['read:billing', 'write:billing']
  },
  {
    href: '/app/stamps',
    icon: AwardIcon,
    title: 'Timbrados',
    scope: ['read:stamps', 'write:stamps']
  },
  {
    href: '/app/payments',
    icon: CreditCardIcon,
    title: 'Cobranzas',
    scope: ['read:payments', 'write:payments']
  },
  {
    href: '/app/daily-cash-closures',
    icon: BriefcaseIcon,
    title: 'Tesorería',
    scope: ['read:daily-cash-closures', 'write:daily-cash-closures']
  },
  {
    href: '/app/product-types',
    icon: LayersIcon,
    title: 'Tipos de productos',
    scope: ['read:product-types', 'write:product-types']
  },
  {
    href: '/app/inventory',
    icon: PackageIcon,
    title: 'Inventario',
    scope: ['read:inventory', 'write:inventory']
  },
  {
    href: '/app/employees',
    icon: UsersIcon,
    title: 'Empleados',
    scope: ['read:employees', 'write:employees']
  },
  {
    href: '/app/activity',
    icon: ActivityIcon,
    title: 'Actividad',
    scope: ['read:activity', 'write:activity']
  },
  {
    href: '/app/conversations',
    icon: ConversationsIcon,
    title: 'Conversaciones',
    scope: ['read:conversations', 'write:conversations']
  },
  {
    href: '/app/settings',
    icon: SettingsIcon,
    title: 'Configuración',
    scope: ['read:settings', 'write:settings']
  }
]);

export default MENU_ITEMS;
